import { IVisaInfo } from "../../types/flights";
import enquiryscss from "../../../sass/enquiry-list/Enquiry.module.scss";

export const EDVisaSub: React.FC<{
  visaEnquiryData: IVisaInfo[] | undefined;
}> = (props) => {
  return (
    <div className={enquiryscss.segmentContainer}>
      {props.visaEnquiryData && props.visaEnquiryData.length > 0 && (
        <h3 className={enquiryscss.enquiryDetailHeading}>Visa Details</h3>
      )}
      {props.visaEnquiryData?.map((visa, index) => (
        <div
          key={`visa-${index}`}
          className={`${enquiryscss.sCrmVisaitem} shadow-sm`}
        >
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-4 col-12 d-flex align-items-end">
              <div className={`visa enquiry-${index}`}>
                Visa Enquiry
                <span className={enquiryscss.bgVisaNo}> {index + 1}</span>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-6 d-flex align-items-end">
              <div className={enquiryscss.vDetailsSubItem}>
                Country Name: <br /> <span> {visa.country} </span>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-6">
              <div className={enquiryscss.vDetailsSubItem}>
                Visa Category: <br /> <span>{visa.visaCategory}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
